import { render, staticRenderFns } from "./DeviceAlertParams.vue?vue&type=template&id=c528a97e&scoped=true"
import script from "./DeviceAlertParams.vue?vue&type=script&lang=js"
export * from "./DeviceAlertParams.vue?vue&type=script&lang=js"
import style0 from "./DeviceAlertParams.vue?vue&type=style&index=0&id=c528a97e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c528a97e",
  null
  
)

export default component.exports